export default "//static.tradera.net/touchweb/static/output/images/qr-code-appstore.39be6aa3.png";